<template>
    <div>
        <common-content-spacer height="medium">
            <div v-if="heading" class="referral-details-card__heading">
                {{ heading }}
            </div>

            <div :class="referralDetailsClass">
                <user-details
                    v-if="showPatient && referral.patient"
                    :user="referral.patient"
                    :size="widgetsSize"
                    :topText="$t('elements.referral_details_card.patient')"
                    :bottomText="patientInsurance"
                    :showPhone="true"
                    :showEmail="showEmail"
                    alignContactDetails="right"
                ></user-details>

                <user-details
                    v-if="showReferring && referral.fromUser"
                    :user="referral.fromUser"
                    :size="widgetsSize"
                    :topText="$t('elements.referral_details_card.referring_physician')"
                    :bottomText="referringRole"
                    :showPhone="true"
                    :showEmail="showEmail"
                    alignContactDetails="right"
                ></user-details>

                <user-details
                    v-if="showReferred && referral.toUser"
                    :user="referral.toUser"
                    :size="widgetsSize"
                    :topText="$t('elements.referral_details_card.referred_physician')"
                    :bottomText="referredSpecialty"
                    :showPhone="true"
                    :showEmail="showEmail"
                    alignContactDetails="right"
                ></user-details>

                <referrals-datetime v-if="showReferralDate" :referral="referral" :size="widgetsSize">
                    <template v-slot:title>
                        {{ dueDateText }}
                    </template>
                </referrals-datetime>
            </div>
        </common-content-spacer>
    </div>
</template>

<script>
    import UserDetails from 'components/page-elements/referrals/details/UserDetailsCard'
    import ReferralsDatetime from 'components/page-elements/ReferralsDatetime'

    export default {
        components: {
            ReferralsDatetime,
            UserDetails,
        },

        props: {
            referral: { type: Object, required: true },
            heading: { type: String, default: null },
            showEmail: { type: Boolean, default: false },
            widgetsSize: { type: String, default: 'medium' },
            showReferring: { type: Boolean, default: true },
            showReferred: { type: Boolean, default: true },
            showReferralDate: { type: Boolean, default: true },
            showPatient: { type: Boolean, default: true },
            showBottomText: { type: Boolean, default: true },
            showReversed: { type: Boolean, default: false },
        },

        computed: {
            referralDetailsClass() {
                return {
                    'referrals-details-card': true,
                    'referrals-details-card__reversed': this.showReversed,
                }
            },

            patientInsurance() {
                return this.showBottomText ? this.referral.insurancePlan.name : null
            },

            referringRole() {
                return this.showBottomText ? this.referral.fromUser.userRole.name : null
            },

            referredSpecialty() {
                return this.showBottomText ? this.referral.speciality.name : null
            },

            dueDateText() {
                return this.$t('pages.referrals.primary_care_insurance.view.due_date')
            },
        },
    }
</script>
